import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: "auto", // Redimensionar automaticamente a altura para manter a proporção
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	}
}));

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();

	// Construir URL completa si es relativa
	let finalImageUrl = imageUrl;
	if (imageUrl && !imageUrl.startsWith('http')) {
		const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
		finalImageUrl = `${backendUrl}${imageUrl}`;
	}

	console.log('[ModalImageCors] imageUrl recibida:', imageUrl);
	console.log('[ModalImageCors] REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL);
	console.log('[ModalImageCors] finalImageUrl construida:', finalImageUrl);

	return (
		<ModalImage
			className={classes.messageMedia}
			smallSrcSet={finalImageUrl}
			medium={finalImageUrl}
			large={finalImageUrl}
			alt="image"
			showRotate={true}
		/>
	);
};

export default ModalImageCors;
